import React from 'react';
import { styled } from 'linaria/react';
import { ContentRenderer } from '@jetshop/ui/ContentRenderer';
import { allContentComponents } from '../ContentComponents/ContentComponents';

const ContentRendererWrapper = styled('div')`
  width: 100%;
`;

const ExplodedPage = ({ result, category }) => {
  const newRoot = category?.data?.items?.map(item => Object.assign({}, item));
  const productList = category?.data?.items?.filter(
    item => item.type === 'explodedProductList'
  );

  if (productList) {
    let extraProducts = [];
    productList.forEach(item => {
      extraProducts.push(...item.children);
    });

    let rootComponent = newRoot?.filter(item => item.type === 'explodedView');
    rootComponent[0].children = [
      ...rootComponent[0].children,
      ...extraProducts
    ];
  }

  return (
    <>
      {newRoot?.length > 0 && (
        <ContentRendererWrapper>
          <ContentRenderer items={newRoot} components={allContentComponents} />
        </ContentRendererWrapper>
      )}
    </>
  );
};

export default ExplodedPage;
